import { HttpHeaders } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { EntitlementsHelperService, LINE_OF_BUSINESS_ENUM, LOGIN_INFO_REDUCER_NAME, UserInfoStateStructure } from '@ptl/account-management';
import { HTTPWrapperContext, RequestConfigImplementation, REQUEST_METHODS, XHR_STRATEGIES, AxwayTokenFetcherService } from '@ptl/xhr';
import { CommonUtilityService } from '../../../../shared/utility-services/common-utility.service';
import { ReducerUtilityService } from '../../../../shared/utility-services/reducer-utility.service';
import { ProducerStateStructure } from '../../configs/interfaces/producerStateStructure.interface';
import { GeneratePdfResponse } from '../interfaces/generate-pdf.interface';
import { GlobalDataStateStructure } from '../../../../angular-elements/shared/components/configs/interfaces/globalStateStructure.interface';
import { API_ENDPOINTS } from 'src/app/shared/constants/api-endpoints.constant';

@Injectable({
  providedIn: 'root'
})
export class GeneratePdfService implements OnInit {

  constructor(
    private httpClient: HTTPWrapperContext,
    private entitlementsHelperService: EntitlementsHelperService,
    private commonUtilityService: CommonUtilityService,
    private reducerUtilityService: ReducerUtilityService,
    private axwayTokenFetcherService: AxwayTokenFetcherService
  ) { }

  ngOnInit() {}


  async makeRequest(url: string): Promise<any>{

    const loginInfo: UserInfoStateStructure = this.reducerUtilityService.getReducerFromApplicationState(LOGIN_INFO_REDUCER_NAME);

    const payload = {
        firstName: loginInfo.userInfo.firstName,
        lastName: loginInfo.userInfo.lastName,
        agentId: loginInfo.userInfo.agencyInfo.selectedAgencies[LINE_OF_BUSINESS_ENUM.SENIOR].agentACSId, 
        agencyId: loginInfo.userInfo.agencyInfo.selectedAgencies[LINE_OF_BUSINESS_ENUM.SENIOR].agencyId
    };

    const requestConfig = new RequestConfigImplementation({
      method: REQUEST_METHODS.POST,
      POST_OR_PUT_PAYLOAD: payload,
      url: this.axwayTokenFetcherService.buildApiUrl(API_ENDPOINTS.REPORTS.MEDICARE_SUPPLIMENT, {}),
      headers: new HttpHeaders({}),
    });

    this.httpClient.setStrategy(XHR_STRATEGIES.AXWAY_POST_PASS_V4);
    return this.httpClient.makeRequest(requestConfig);
  }

  async downloadPdf() {
    let url =  `/cmcrst/x-services/public/medicare/suppliment/generatepdf`;

    let response: GeneratePdfResponse = await this.makeRequest(url);

    if (response.status && response.status.toLowerCase() === "success") {
      const blob = this.getBlobData(response.base64data, response.mimeType);
      const blobUrl = window.URL.createObjectURL(blob);

      var link = document.createElement('a');
      link.href = blobUrl;
      link.target = '_blank';
      link.setAttribute('download', response.filename);

      //In FF link must be added to DOM to be clicked
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  

  private getBlobData(base64raw: string, contentType: string) {
    var sliceSize = 512;
    var base64decoded = atob(base64raw);
    var base64bytes = [];

    for (var offset = 0; offset < base64decoded.length; offset += sliceSize) {
      var slice = base64decoded.slice(offset, offset + sliceSize);

      var sliceArray = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        sliceArray[i] = slice.charCodeAt(i);
      }

      var sliceBytes = new Uint8Array(sliceArray);

      base64bytes.push(sliceBytes);
    }

    return new Blob(base64bytes, { type: contentType });
  }




}
